import {apiService} from '../apiService';

export const autoresponderService = apiService.injectEndpoints({
    endpoints: (builder) => ({
        getAutoresponderRules: builder.query({
            query: (formId) => ({
                url: `/forms/${formId}/autoresponder`
            }),
            providesTags: (_res, _err, formId) => [{type: 'Autoresponder', id: formId}],
        }),
        saveAutoresponderRule: builder.mutation({
            query: ({formId, rule}) => ({
                url: `/forms/${formId}/autoresponder/rules`,
                method: 'post',
                data: rule,
            }),
            invalidatesTags: (_res, _err, {formId}) => [{type: 'Autoresponder', id: formId}],
        }),
        deleteAutoresponderRule: builder.mutation({
            query: ({formId, ruleId}) => ({
                url: `/forms/${formId}/autoresponder/rules/${ruleId}`,
                method: 'delete',
            }),
            invalidatesTags: (_res, _err, {formId}) => [{type: 'Autoresponder', id: formId}],
        }),
    }),
});

export const {
    useGetAutoresponderRulesQuery,
    useSaveAutoresponderRuleMutation,
    useDeleteAutoresponderRuleMutation
} = autoresponderService;
